import type { PrinterProfile } from "@/api/client";

export function vendorModel(profile: Pick<PrinterProfile, "vendor" | "model">) {
  return [profile.vendor, profile.model].filter(Boolean).join(" ") || "-";
}

/** None without an address; otherwise whether the server may contact it (PRINT_IPP_ALLOWED_HOSTS). */
export function ippLabel(profile: Pick<PrinterProfile, "ipp_uri" | "ipp_allowed">) {
  if (!profile.ipp_uri) return "None";
  return profile.ipp_allowed ? "Allowed" : "Not allowed";
}

export function marginsLabel(profile: Pick<PrinterProfile, "margin_top_mm" | "margin_right_mm" | "margin_bottom_mm" | "margin_left_mm">) {
  const side = (label: string, value: number | null) => `${label} ${value === null ? "template" : `${value} mm`}`;
  return [
    side("Top", profile.margin_top_mm),
    side("right", profile.margin_right_mm),
    side("bottom", profile.margin_bottom_mm),
    side("left", profile.margin_left_mm),
  ].join(", ");
}
